import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useWorkspace, useWorkspaceId } from '@/lib/contexts';

type Props = {
  children: ReactNode;
};

const ActivityReportsGuard = ({ children }: Props) => {
  const { workspace } = useWorkspace();
  const workspaceId = useWorkspaceId();

  const activityReportsEnabled = workspace?.activityReportsEnabled;

  if (activityReportsEnabled === false) {
    return (
      <Navigate to={`/workspaces/${workspaceId}/activity-reports`} replace />
    );
  }

  return <>{children}</>;
};

export default ActivityReportsGuard;
